/* ============================================================
   Notre Chanson — samples.js
   Lecteurs audio réels pour les cartes « Écoutez d'autres
   chansons » : play/pause, waveform de progression, seek au clic,
   temps écoulé. Une seule chanson joue à la fois.

   Générique : s'accroche à toute carte [data-sample] présente sur
   la page — aucune dépendance à une page en particulier.
   ============================================================ */
(function () {
  'use strict';

  /* Motifs de waveform (0..1 → hauteur de barre). Un motif distinct
     par carte pour que les trois extraits ne se ressemblent pas. */
  var PATTERNS = [
    [.22,.48,.65,.38,.72,.55,.90,.42,.78,.50,.35,.82,.60,.45,.70,.88,.55,.32,.68,.50,.75,.40,.60,.28,.52],
    [.52,.35,.78,.42,.65,.28,.82,.50,.70,.38,.60,.88,.45,.32,.75,.55,.68,.40,.80,.48,.30,.62,.72,.44,.58],
    [.38,.62,.28,.75,.45,.88,.55,.32,.70,.50,.85,.42,.65,.78,.35,.58,.72,.48,.30,.80,.55,.38,.68,.42,.60]
  ];

  function fmt(t) {
    if (!isFinite(t) || t < 0) return '—';
    t = Math.floor(t);
    var m = Math.floor(t / 60), s = t % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  var players = [];

  document.querySelectorAll('[data-sample]').forEach(function (card, i) {
    var audio = card.querySelector('[data-sample-audio]');
    var btn   = card.querySelector('[data-sample-play]');
    var wave  = card.querySelector('[data-sample-wave]');
    var elCur = card.querySelector('[data-sample-cur]');
    var elTot = card.querySelector('[data-sample-tot]');
    var elMeta = card.querySelector('[data-sample-total]');
    if (!audio || !btn || !wave) return;

    var pattern = PATTERNS[i % PATTERNS.length];
    var bars = pattern.map(function (h) {
      var b = document.createElement('span');
      b.className = 'nm-sample__bar';
      b.style.height = (24 + h * 76) + '%';
      wave.appendChild(b);
      return b;
    });

    /* La durée réelle du fichier remplace la valeur écrite en dur
       dès que les métadonnées arrivent — jamais de minutage faux. */
    function setDuration() {
      var d = audio.duration;
      if (!isFinite(d)) return;
      if (elTot) elTot.textContent = fmt(d);
      if (elMeta) elMeta.textContent = fmt(d);
    }
    function paint() {
      var d = audio.duration, p = (isFinite(d) && d > 0) ? audio.currentTime / d : 0;
      var n = Math.round(p * bars.length);
      for (var j = 0; j < bars.length; j++) bars[j].classList.toggle('is-played', j < n);
      if (elCur) elCur.textContent = fmt(audio.currentTime);
      wave.setAttribute('aria-valuenow', Math.round(p * 100));
    }
    function seek(clientX) {
      var r = wave.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
      if (isFinite(audio.duration)) { audio.currentTime = ratio * audio.duration; paint(); }
    }

    audio.addEventListener('loadedmetadata', setDuration);
    audio.addEventListener('durationchange', setDuration);
    audio.addEventListener('timeupdate', paint);
    audio.addEventListener('play', function () {
      players.forEach(function (p) { if (p.audio !== audio) p.audio.pause(); });
      card.classList.add('is-playing');
    });
    audio.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    audio.addEventListener('ended', function () { audio.currentTime = 0; paint(); });

    btn.addEventListener('click', function () {
      if (audio.paused) { var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
      else { audio.pause(); }
    });
    wave.addEventListener('click', function (e) { seek(e.clientX); });
    wave.addEventListener('keydown', function (e) {
      if (!isFinite(audio.duration)) return;
      if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); paint(); }
      else if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - 5); paint(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
    });

    players.push({ audio: audio });
    setDuration();
    paint();
  });
})();
